import { createAction } from "@reduxjs/toolkit";
import type { TeacherPayoutEligibilityVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const teacherRetrievePayoutRequestEligibility = createApiThunk<TeacherPayoutEligibilityVM, void>(
  "payouts/teacherRetrievePayoutRequestEligibility",
  async (_, { extra: { teacherRepository } }) => {
    return teacherRepository!.getPayoutEligibility();
  },
);

export const resetTeacherRetrievePayoutRequestEligibility = createAction("payouts/resetTeacherRetrievePayoutRequestEligibility");
